import React from "react";

function DossierIcon() {
  return (
    <div>
      <svg
        width="44"
        height="39"
        viewBox="0 0 44 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_647_5983)">
          <path
            d="M5.78963 11.5781V10.3594H5.21068C2.65173 10.3594 0.579102 8.17781 0.579102 5.48438C0.579102 2.79094 2.65173 0.609375 5.21068 0.609375H36.4738V11.5781H5.78963Z"
            fill="#E2D8FF"
          />
          <path
            d="M35.8947 1.21875V10.9688H6.36842V9.75H5.21053C2.97579 9.75 1.15789 7.83656 1.15789 5.48438C1.15789 3.13219 2.97579 1.21875 5.21053 1.21875H35.8947ZM37.0526 0H5.21053C2.33895 0 0 2.44969 0 5.48438C0 8.51906 2.33895 10.9688 5.21053 10.9688V12.1875H37.0526V0Z"
            fill="#460AF0"
          />
          <path
            d="M5.21094 4.875H39.9478V33.5156H5.21094V4.875Z"
            fill="#E2D8FF"
          />
          <path
            d="M39.3687 4.875V32.9062H5.78973V4.875H39.3687ZM40.5266 3.65625H4.63184V34.125H40.5266V3.65625Z"
            fill="#460AF0"
          />
          <path
            d="M5.78906 29.25V7.3125H18.5259C24.2691 7.3125 28.947 12.2362 28.947 18.2812C28.947 24.3263 24.2691 29.25 18.5259 29.25H5.78906Z"
            fill="white"
          />
          <path
            d="M5.78963 38.3906C2.91805 38.3906 0.579102 35.9287 0.579102 32.9062V6.09375H0.613838C0.903312 8.49469 2.84858 10.3594 5.21068 10.3594H36.4738V38.3906H5.78963Z"
            fill="#E2D8FF"
          />
          <path
            d="M1.15789 8.92125C2.11895 10.1644 3.5779 10.9688 5.21053 10.9688H35.8947V37.7812H5.78947C3.23053 37.7812 1.15789 35.5997 1.15789 32.9062V8.92125ZM1.15789 5.48438H0V32.9062C0 36.27 2.59368 39 5.78947 39H37.0526V9.75H5.21053C2.97579 9.75 1.15789 7.83656 1.15789 5.48438Z"
            fill="#460AF0"
          />
          <path
            d="M28.3682 20.1094H43.4208V28.6406H28.3682V20.1094Z"
            fill="#E2D8FF"
          />
          <path
            d="M42.8417 20.7188V28.0312H28.947V20.7188H42.8417ZM43.9996 19.5H27.7891V29.25H43.9996V19.5Z"
            fill="#460AF0"
          />
          <path
            d="M33.5788 23.1562C32.942 23.1562 32.4209 23.7047 32.4209 24.375C32.4209 25.0453 32.942 25.5938 33.5788 25.5938C34.2156 25.5938 34.7367 25.0453 34.7367 24.375C34.7367 23.7047 34.2156 23.1562 33.5788 23.1562Z"
            fill="#460AF0"
          />
        </g>
        <defs>
          <clipPath id="clip0_647_5983">
            <rect width="44" height="39" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default DossierIcon;
